/**
 * 公共正则表达式验证器
 */

const validator = {
  // 手机号（中国大陆）
  phone: /^1[3-9]\d{9}$/,

  // 邮箱
  email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,

  // 英文
  eng: /^[a-zA-Z\s]+$/,

  /**
   * 手机号验证
   */
  isPhone(value) {
    return this.phone.test(value)
  },

  /**
   * 邮箱验证
   */
  isEmail(value) {
    return this.email.test(value)
  },

  /**
   * 纯英文
   */
  isEng(value) {
    return this.eng.test(value)
  },

  /**
   * 通用验证方法
   */
  validate(value, type, ...args) {
    const methodName = `is${type.charAt(0).toUpperCase() + type.slice(1)}`
    if (typeof this[methodName] === 'function') {
      return this[methodName](value, ...args)
    }
    return false
  }
}

export default validator